import React, { Component } from 'react';
import logo from './img/dirad_logo.png';
import { FaIdBadge, FaMicrosoft } from 'react-icons/fa';

export default class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			errorBg: 0,
			loginConfig: [
				{
					data: "email",
					type: "text",
					label: "Email Address",
					error: ""
				},
				{
					data: "password",
					type: "password",
					label: "Password",
					error: ""
				}
			],
			loginCreds: {},
		}
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.login()
		}
	}

	fieldChange = (e) => {
		var newCreds = this.state.loginCreds
		newCreds[e.currentTarget.getAttribute('data-value')] = e.currentTarget.value
		this.setState({ loginCreds: newCreds })
	}

	login = (e) => {
		this.setState({ loading: true });
		this.props.saveCreds(this.state.loginCreds)
		window.setTimeout(function () {
			this.props.ws.send(JSON.stringify({ route: 'login', loginCreds: this.state.loginCreds }))
		}.bind(this), 200)
	}

	loginWithMicrosoft = (e) => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'loginWithMicrosoft' }))
	}
	loginWithAzureAD = (e) => {
		console.log("Login with Azure AD")
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'loginWithAzureAD' }))
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.setState({ loading: false, errorBg: 1 });
		}
		setTimeout(function () {
			this.setState({ errorBg: 0 });
		}.bind(this), 1000)
	}

	render() {
		var loginComps = []
		var isHttps = window.location.protocol === 'https:';

		// Public (non-secret) auth config pushed from backend (e.g. over websocket)
		// Expecting: this.props.publicAuthConfig = { sso: { name: 'ACS' }|false, signInWithMicrosoft: true|false }
		const publicAuthConfig = this.props?.publicAuthConfig || {};
		const ssoName = publicAuthConfig?.sso && publicAuthConfig.sso !== false
			? publicAuthConfig?.sso?.name
			: null;
		const showSsoButton = !!(ssoName && String(ssoName).trim());

		const showMicrosoftButton = !!publicAuthConfig?.signInWithMicrosoft;
		const showAltLoginOptions = showMicrosoftButton || showSsoButton;
		console.log({ showMicrosoftButton, showSsoButton, showAltLoginOptions });

		for (var comp of this.state.loginConfig) {
			loginComps.push(
				<div className="snazzyInputBox" key={comp.data}>
					<div className="error">{comp.error}</div>
					<input className="textInput" type={comp.type} required value={this.state.loginCreds[comp.data] ? this.state.loginCreds[comp.data] : ''} data-value={comp.data} onChange={this.fieldChange} ></input>
					<span className="inputBar"></span>
					<label className="textLabel">{comp.label}</label>
				</div>
			)
		}

		return (
			<div className="App ">
				<div className="backdrop"></div>

				<div className="loginBox" onKeyUp={this.checkEnter}>
					<img src={logo} className="App-logo" alt="logo" />

					{loginComps}

					<div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
						{this.props.loginError ? <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.props.loginError}</div> : ''}
						{this.state.loading ?
							<div className="loader"></div>

							:
							<div>
								{/* Primary login button */}
								<div style={{ maxWidth: '420px', width: '100%', margin: '0 auto' }}>
									<div
										className="button"
										onClick={this.login}
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											gap: '10px',
											padding: '12px 16px',
											width: '100%',
											boxSizing: 'border-box',
											minHeight: '44px',
											lineHeight: '16px'
										}}
									>
										Log In
									</div>
								</div>

								{/* Alternative login options */}
								{showAltLoginOptions && (
									<div style={{ marginTop: '10px' }}>
										{/* Divider */}
										<div style={{ height: '40px', position: 'relative', margin: '0 auto 10px auto', maxWidth: '420px', width: '100%' }}>
											<div style={{ width: '100%', backgroundColor: '#BBB', height: '2px', top: '20px', position: 'absolute' }}></div>
											<div style={{ width: '52px', backgroundColor: '#fff', position: 'absolute', transform: 'translateX(-50%)', top: '10px', left: '50%', textAlign: 'center' }}>
												or
											</div>
										</div>

										{/* Buttons */}
										<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '420px', width: '100%', margin: '0 auto' }}>
											{showMicrosoftButton && (
												<div
													className="button"
													onClick={this.loginWithMicrosoft}
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'flex-start',
														gap: '10px',
														padding: '12px 16px',
														width: '100%',
														boxSizing: 'border-box',
														minHeight: '44px',
														lineHeight: '16px'
													}}
												>
													<FaMicrosoft size={20} style={{ minWidth: '20px' }} />
													<div style={{ lineHeight: '18px', whiteSpace: 'normal' }}>Sign in with Microsoft</div>
												</div>
											)}

											{showSsoButton && (
												<div
													className="button"
													onClick={this.loginWithAzureAD}
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'flex-start',
														gap: '10px',
														padding: '12px 16px',
														width: '100%',
														boxSizing: 'border-box',
														minHeight: '44px',
														lineHeight: '16px'
													}}
												>
													<FaIdBadge size={20} style={{ minWidth: '20px' }} />
													<div style={{ fontSize: '16px', lineHeight: '16px', whiteSpace: 'nowrap' }}>
														Sign in with your {String(ssoName).trim()} account
													</div>
												</div>
											)}
										</div>
									</div>
								)}
							</div>
						}

						{false ? <div style={{ padding: '15px' }}>Forgot Password?</div> : ''}
					</div>
				</div >
			</div >
		)
	}
}
